import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private http = inject(HttpClient);


  get<T>(endpoint: string, options?: object): Observable<T> {
    return this.http.get<T>(`${environment.apiUrl}${endpoint}`, options);
  }

  post<T>(endpoint: string, data: any, options?: object): Observable<T> {
    return this.http.post<T>(`${environment.apiUrl}${endpoint}`, data, options);
  }

  put<T>(endpoint: string, data: any, options?: object): Observable<T> {
    return this.http.put<T>(`${environment.apiUrl}${endpoint}`, data, options);
  }

  delete<T>(endpoint: string): Observable<T> {
    return this.http.delete<T>(`${environment.apiUrl}${endpoint}`);
  }

  // Métodos para APIs externas (sem environment.apiUrl)
  getExternal<T>(
    url: string,
    headers?: HttpHeaders | Record<string, string>
  ): Observable<T> {
    const httpHeaders = headers
      ? headers instanceof HttpHeaders
        ? headers
        : new HttpHeaders(headers)
      : new HttpHeaders();
    return this.http.get<T>(url, { headers: httpHeaders });
  }

  postExternal<T>(
    url: string,
    data: any,
    headers?: HttpHeaders | Record<string, string>
  ): Observable<T> {
    const httpHeaders = headers
      ? headers instanceof HttpHeaders
        ? headers
        : new HttpHeaders(headers)
      : new HttpHeaders();
    return this.http.post<T>(url, data, { headers: httpHeaders });
  }

  putExternal<T>(
    url: string,
    data: any,
    headers?: HttpHeaders | Record<string, string>
  ): Observable<T> {
    const httpHeaders = headers
      ? headers instanceof HttpHeaders
        ? headers
        : new HttpHeaders(headers)
      : new HttpHeaders();
    return this.http.put<T>(url, data, { headers: httpHeaders });
  }

  deleteExternal<T>(
    url: string,
    headers?: HttpHeaders | Record<string, string>
  ): Observable<T> {
    const httpHeaders = headers
      ? headers instanceof HttpHeaders
        ? headers
        : new HttpHeaders(headers)
      : new HttpHeaders();
    return this.http.delete<T>(url, { headers: httpHeaders });
  }
}
